import VueMatomo from 'vue-matomo'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueMatomo, {
    host: 'https://stats.1hosting.com',
    siteId: 59,
    router: nuxtApp.$router,
    userId: useUserStore().userEmail
  })
})
